import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import EditorSidebar from './EditorSidebar/EditorSidebar';
import EditorBody from './EditorBody';

function SMCEditor({
    pages,
    chosenPageId,
    setChosenPageId,
    onPageChange,
    editorPageData,
    errorListByPage,
    height,
    width,
    isPageLoaded,
    isPageLoadFailed,
    reloadData
}) {
    const idToPageElement = useMemo(() => {
        const mapPageIdToPageElement = (pagesData) => {
            let idToPageElementBuilder = {};
            pagesData.forEach(pageData => {
                idToPageElementBuilder[pageData.id] = pageData.pageElement;
                if (pageData.children) {
                    idToPageElementBuilder = {...idToPageElementBuilder, ...mapPageIdToPageElement(pageData.children)};
                }
            });
            return idToPageElementBuilder;
        }
        return mapPageIdToPageElement(pages);
    }, [pages]);

    const currentPage = idToPageElement[chosenPageId];
    const fixed_height = height-40;
    return (
        <div className="ObjectEditorBody">
            <EditorSidebar
                height={fixed_height}
                width={230}
                onSelectPage={pageId => {setChosenPageId && setChosenPageId(pageId); onPageChange && onPageChange(pageId);}}
                tabs={pages}
                errorListByPage={errorListByPage}
                selectedTabId={chosenPageId}
                isPageLoaded={isPageLoaded}
            />
            <EditorBody
                reloadData={reloadData}
                isPageLoadFailed={isPageLoadFailed}
                height={fixed_height}
                width={width-230}
                editorPageData={editorPageData}
                EditorPageElement={currentPage}
                isPageLoaded={isPageLoaded}
            />
        </div>
    );
}

SMCEditor.propTypes = {
    pages: PropTypes.arrayOf(PropTypes.object).isRequired,
    editorPageData: PropTypes.object,
    reloadData: PropTypes.func,
    height: PropTypes.number,
    isPageLoaded: PropTypes.bool,
    isPageLoadFailed: PropTypes.bool
}

export default SMCEditor;
